import TransactionService from "@/services/transaction.service";

export default {
    data() {
        return {
            isModalCustomClass: false,
            showModalBetslip: false,
            listBetslips: [],
            commonStake: 0,
            totalStake: 0,
            isDisableProcessBet: false,
            showModalProcessBet: false,
            showModalConfirmBet: false,
            refBetConfirmationDetail: '',
            loadingProcessBet: false,
            loadingBootABet: false,
            nextDraws: {},
            drawsExpired: [],
            betDraws: [],
            bets: [],
            isShowErrorExpired: false,
            isShowResBookABet: false,
            bookingCodeBootABet: null,
            accountSettings: {},
            loadingBookTicket: false,
        };
    },
    watch: {
        listBetslips(val) {
            if(val) {
                let total = 0;
                val.forEach(item => {
                    total = total + parseInt(item.stake)
                })
                this.totalStake = total;
            }
        },
        settings(val) {
            if (val) {
                this.accountSettings = val;
            }
        }
    },
    created() {
        const parameters = this.$route.query
        if (parameters) {
            this.$store.dispatch('initDataCustomer', parameters)
        }
        this.$store.dispatch('apiGetSettings');
    },
    computed: {
        draws() {
            return this.$store.getters.getDraws
        },
        settings() {
            return this.$store.getters.getSettings
        },
    },
    methods: {
        handleToggleClassModal(value) {
            this.isModalCustomClass = value;
        },
        handleRemoveItemBetslip(value) {
            this.listBetslips = this.listBetslips.filter((item, index)=> index !== value)
            this.saveBetslipsToStore()
            this.checkExpired(this.listBetslips);
        },
        handleRemoveAllBetslips() {
            this.isShowResBookABet = false;
            this.listBetslips = []
            this.saveBetslipsToStore()
            this.checkExpired(this.listBetslips);
        },
        removeDrawsExpired() {
            this.listBetslips = this.listBetslips.filter(bet=> !this.drawsExpired.includes(bet.startDrawId))
            this.saveBetslipsToStore()
            this.checkExpired(this.listBetslips);
            let drawsStorage = localStorage.getItem('draws')
            if(drawsStorage) {
                drawsStorage = JSON.parse(drawsStorage)
                drawsStorage = drawsStorage.filter(draw=> !this.drawsExpired.includes(draw.external_draw_id))
                localStorage.setItem('draws', JSON.stringify(drawsStorage))
            }
        },
        moveToNextDraw() {
            this.listBetslips.forEach(bet=> {
                for (const [k, v] of Object.entries(this.nextDraws)) {
                    if(k === bet.slug) {
                        bet.startDrawId = v.external_draw_id
                        bet.isBetExpired = false;
                        bet.newDrawName = `${bet.drawName} ${this.$filters.formatDate(v.draw_date)}`
                    }
                }
            })
            let drawsStorage = localStorage.getItem('draws')
            if(drawsStorage) {
                drawsStorage = JSON.parse(drawsStorage)
                drawsStorage = drawsStorage.filter(draw=> !this.drawsExpired.includes(draw.external_draw_id))
                for (const [_, v] of Object.entries(this.nextDraws)) {
                    drawsStorage = [...drawsStorage, v]
                }
                localStorage.setItem('draws', JSON.stringify(drawsStorage))
            }
            this.checkExpired(this.listBetslips);
            this.saveBetslipsToStore()
        },
        saveBetslipsToStore() {
            localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
            this.$store.dispatch('changeBadgeNumber', this.listBetslips.length);
        },
        handleConfirmItem(ref) {
            this.refBetConfirmationDetail = ref;
            this.showModalBetslip = false;
            this.showModalProcessBet = false;
            this.showModalConfirmBet = true;
        },
        handleViewBetSlip() {
            let yourBetslipStorage = localStorage.getItem('yourBetslip')
            if(yourBetslipStorage) {
                yourBetslipStorage = JSON.parse(yourBetslipStorage)
                this.listBetslips = yourBetslipStorage;
                const even = (element) => element.stake > element.MaxStake || element.stake === 0
                    || element.stake === null || element.stake === '';
                this.isDisableProcessBet = this.listBetslips.some(even);
            } else {
                this.isDisableProcessBet = true;
            }
            this.showModalBetslip = true
        },
        handleBookABet() {
            this.loadingBootABet = true;
            let listData = [];
            listData = this.listBetslips.map(betslip => {
                let listMarketOdds = [];
                let maxPayout = null;
                for (const property in betslip?.bets?.outcomes) {
                    if(Number(betslip.odds) === Number(betslip?.bets?.outcomes[property].odds)) {
                        maxPayout = betslip?.bets?.outcomes[property].max_payout;
                    }
                    listMarketOdds.push(betslip?.bets?.outcomes[property].odds);
                }
                const bets = {
                    has_number_selection: betslip?.bets?.select_numbers,
                    selection: [{
                        numbers: betslip.numbers,
                        description: betslip?.bets?.description,
                        summary: betslip?.bets?.summary,
                        outcomeId: betslip.outcome,
                        specifier: betslip?.bets?.specifier,
                        to_win: betslip.toWin,
                        odds: betslip.odds,
                        text: betslip.text,
                        stake: betslip.stake,
                        draws: betslip.draws,
                        numOfBets: betslip.numOfBets,
                        totalCombinations: 0, // todo update
                        payoutList: [], // todo update
                        systemBets: betslip.systemBets,
                        newSystemBets: {}, // todo update
                        isFreeBet: betslip.isFreeBet,
                        wheelingId: betslip.wheelingId,
                        maxPayout: maxPayout,
                        hasData: true, // todo update,
                        newDrawName: betslip.newDrawName
                    }],
                    numOfBets: betslip.numOfBets,
                    marketOdds: listMarketOdds,
                    betType: betslip.betType,
                    nextIndex: 0, // todo update,
                    market: betslip.market,
                }
                return {
                    name: betslip.drawName,
                    slug: betslip.slug,
                    draw_id: betslip.startDrawId,
                    draw_date: betslip.drawDate,
                    bets: [bets]
                };
            })

            let listBookABets = listData.reduce(function(o, cur) {
                const occurs = o.reduce(function(n, item, i) {
                    return (item.draw_id === cur.draw_id) ? i : n;
                }, -1);
                if (occurs >= 0) {
                    o[occurs].bets = o[occurs].bets.concat(cur.bets);
                } else {
                    const obj = {
                        name: cur.name,
                        slug: cur.slug,
                        draw_id: cur.draw_id,
                        draw_date: cur.draw_date,
                        bets: cur.bets
                    };
                    o = o.concat([obj]);
                }
                return o;
            }, []);

            listBookABets.forEach(bet => {
                bet.bets = bet.bets.reduce(function(o, cur) {
                    const occurs = o.reduce(function(n, item, i) {
                        return (item.market === cur.market) ? i : n;
                    }, -1);
                    if (occurs >= 0) {
                        o[occurs].selection = o[occurs].selection.concat(cur.selection);
                    } else {
                        const obj = {
                            betType: cur.betType,
                            has_number_selection: cur.has_number_selection,
                            market: cur.market,
                            marketOdds: cur.marketOdds,
                            numOfBets: cur.numOfBets,
                            selection: cur.selection
                        };
                        o = o.concat([obj]);
                    }
                    return o;
                }, []);
                bet.bets = bet.bets.map(itemBet => {
                    return {[itemBet.market]: itemBet}
                })
            })

            TransactionService.apiBookABet(listBookABets, this.totalStake).then(res=> {
                if (res.status === "success") {
                    this.isShowResBookABet = true;
                    this.bookingCodeBootABet = res.reference;
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listBetslips.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listBetslips.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listBetslips.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
                    this.$toast.error(res.message, {position: 'top-right'});
                    this.checkExpired(this.listBetslips);

                }
                this.loadingBootABet = false;
            })
        },
        handleProcessBet() {
            this.betDraws = [];
            this.bets = [];
            this.loadingProcessBet = true;
            this.listBetslips.forEach(item => {
                const { bets, drawDate, newDrawName, key, slug, Main, shortText, Extra, drawName, MaxStake, toWin, moreDrawName, ...newItem } = item;
                this.betDraws.push(item.startDrawId)
                this.betDraws = this.betDraws.filter((item, index) => this.betDraws.indexOf(item) === index);
                if (this.bets.some(e => e.slug === item.slug)) {
                    this.bets.forEach(bet=> {
                        if(bet.slug === item.slug) {
                            bet.entries.push(newItem)
                        }
                    })
                } else {
                    this.bets.push(
                        {
                            slug: item.slug,
                            systemType: "Single",
                            price: this.totalStake,
                            entries: [newItem]
                        }
                    )
                }
            })
            TransactionService.apiSubmitTransaction({bets: this.bets, draws: this.betDraws}).then(res => {
                if (res.status === "success") {
                    this.$toast.success(res.message, { position: 'top-right' })
                    this.showModalBetslip = false;
                    this.showModalProcessBet = true;
                    this.listBetslips = [];
                    localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listBetslips.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listBetslips.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listBetslips.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
                    this.$toast.error(res.message, {position: 'top-right'})
                }
                this.checkExpired(this.listBetslips);
                this.loadingProcessBet = false;
            })
        },
        checkExpired(data) {
            const even = (element) => element.isBetExpired === true;
            this.isShowErrorExpired = data.some(even);
        },
        handleLogin() {
            this.showModalBetslip = false;
            this.$router.push('Login')
        },
        async handleChangeStake(value) {
            switch (value.type) {
                case 'common': {
                    this.totalStake = value.val * this.listBetslips.length;
                    this.listBetslips.forEach(item => {
                        let stake = value.val;
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.paid = stake;
                        item.error = stake > item.MaxStake;
                        this.isDisableProcessBet = item.error
                    })
                    break;
                }
                case 'total': {
                    this.totalStake = Number(value.val);
                    let stake = Number(value.val) / this.listBetslips.length;
                    this.listBetslips.forEach(item=> {
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.paid = stake;
                        item.error = stake > item.MaxStake;
                        this.isDisableProcessBet = item.error
                    })
                    break;
                }
                case 'list': {
                    this.listBetslips = value.val;
                    this.totalStake = value.totalStake;
                    this.listBetslips.forEach(item => {
                        let stake = item.stake
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.paid = stake;
                        item.error = stake > item.MaxStake;
                        this.isDisableProcessBet = item.error
                    })
                    break;
                }
            }
            const even = (element) => element.stake > element.MaxStake || Number(element.stake) === 0
                || element.stake === null || element.stake === '' || element.error;
            this.isDisableProcessBet = this.listBetslips.some(even);
            localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
        }
    }
};
